import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const analysisDimensionApi = tokenSlice.injectEndpoints({
  reducerPath: 'analysisDimension',
  baseQuery: createBaseQuery(),
  tagTypes: ['AnalysisDimension'],
  endpoints(builder) {
    return {

      // GET

      getDimensionByBusinessUnit: builder.query({
        query: (id) => ({
          url: `AnalysisDimension/ByBusinessUnit/${id}`,
          method: 'GET',
        }),
        providesTags: ['AnalysisDimension'],
      }),

      // POST

      postAnalysisDimensionSave: builder.mutation({
        query: (data) => ({
          url: 'AnalysisDimension/Save',
          method: 'POST',
          body: data
        }),
        invalidatesTags: ['AnalysisDimension'],
      }),

      // DELETE

      deleteAnalysisDimensionDelete: builder.mutation({
        query: (data) => ({
          url: 'AnalysisDimension/Delete',
          method: 'DELETE',
          body: data
        }),
        invalidatesTags: ['AnalysisDimension']
      }),
    }
  }
})

export const {
  useGetDimensionByBusinessUnitQuery, useDeleteAnalysisDimensionDeleteMutation, usePostAnalysisDimensionSaveMutation } = analysisDimensionApi;
export { analysisDimensionApi };